import React from "react";
import {
  DesignInfoInputDialogContent,
  DesignInfoInputDialogStateProvider,
} from ".";

export const DesignInfoInputDialog = () => {
  return (
    <DesignInfoInputDialogStateProvider>
      <DesignInfoInputDialogContent></DesignInfoInputDialogContent>
    </DesignInfoInputDialogStateProvider>
  );
};
